/* @format */

import { ProductPrimaryCategory } from './product-primary-category.interface';
import { ProductStyleSeo } from './product-style-seo.interface';
import { ProductSku } from './product-sku.interface';
import { StyleDescriptiveAttribute } from './style-descriptive-attribute.interface';
import { ProductStylePrices } from './product-style-prices.interface';
import { StyleDefiningAttribute } from './style-defining-attribute.interface';
import { SkuAttribute } from './sku-attribute.interface';
import { AnalyticsPricingBuckets } from './product/analytics-pricing-bucket.interface';

type fieldsToOmit =
  | 'prices'
  | 'definingAttributes'
  | 'descriptiveAttributes'
  | 'leadTime'
  | 'parentPartNumber'
  | 'shipClass'
  | 'shipQty';

export interface ProductStyle extends Omit<ProductSku, fieldsToOmit> {
  // Gets set in product-selection.service.ts during sku bucketing
  analyticsPricingBuckets?: AnalyticsPricingBuckets;
  // Gets set in product-selection.service.ts
  colorAttributeBuckets?: SkuAttribute[];
  // Not present on out-of-stock products
  definingAttributes?: StyleDefiningAttribute[];
  descriptiveAttributes: StyleDescriptiveAttribute[];
  // Gets set in product-selection.service.ts
  disableSkuLevelPricing?: boolean;
  gtgtenabled?: boolean;
  image?: string;
  // Not present on out-of-stock products
  prices?: ProductStylePrices;
  primaryCategories?: ProductPrimaryCategory;
  redirect: boolean;
  seo: ProductStyleSeo;
  shortDescription?: string;
  sizeChart?: string;
  techSpecs?: string;
}
